angular.module('ringsService', ['ui.router','constants'])
.factory('ringsService', function($http, $q, $rootScope,$interval,myConfig,$rootScope) {

  var service = {};

  var _baseUrl = myConfig.apiUrl + 'rings/';

  /*
  * get number of unprocessed ringorders and number of retraps
  */
  service.ringorders = {created: 0, approved: 0, retraps: 0};
  service.periodicUpdateRunning = false;

  /*
  * update ringorder stats every 60 sec
  */
  service.doPeriodicUpdate = function() {
    if ($rootScope.user && !service.periodicUpdateRunning){
      service.periodicUpdateRunning = true;
      service.updateNRingOrders();
      $interval(function(){
        if ($rootScope.user){
          if (typeof $rootScope.user.UID !== 'undefined' && $rootScope.user.UID != null){
            service.updateNRingOrders();
          }
        }        
      },60000);
    }   
  }

  /*
  * retrieve statistics about ringorders and unprocessed retraps
  */
  service.updateNRingOrders = function(){
    var tableName = 'ringorder?count=true';
    var userToken = localStorage.getItem('userToken');
    var deferred = $q.defer();
    $http({
      method: 'GET',
      url: _baseUrl + tableName,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      service.ringorders = response.data;
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  // get ringer info for given ringnumber
  service.fetchRingerInfo = function(additionalUrl){
    var tableName = 'vw_user_of_ring';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName ;
    if (typeof additionalUrl !== undefined){
      //url += '?' + encodeURIComponent(additionalUrl)
      url += additionalUrl;
    }
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get list of available series for given user
  */
  service.fetchRingsSeries = function(additionalUrl){
    var tableName = 'vw_rings_serie_overview';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName ;
    if (typeof additionalUrl !== undefined){
      //url += '?' + encodeURIComponent(additionalUrl)
      url += '?' + additionalUrl;
    }
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get list of available series for given user
  */
  service.fetchUsedRingsSeries = function(additionalUrl){
    var tableName = 'user_used_rings';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName ;
    if (typeof additionalUrl !== undefined){
      //url += '?' + encodeURIComponent(additionalUrl)
      url += '?' + additionalUrl;
    }
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get list of rings for given user
  */
  service.deleteRingOrderItem = function(idVal){
    var tableName = 'ringorderitem';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName + '?id=' + idVal;
    
    $http({
      method: 'DELETE',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * edit ring order
  */
  service.editRingOrderItem = function(data){
    var tableName = 'ringorderitem';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName;
    $http({
      method  :'PUT',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }  

  /*
  * edit ring order - raw data, with no action
  */
  service.editRingOrderRaw = function(data){
    var tableName = 'ringorder_raw';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName;
    $http({
      method  :'PUT',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  } 

  
  /*
  * get list of rings for given user
  */
  service.fetchRingOrders = function(additionalUrl){
    var tableName = 'vw_ring_orders';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    //var userId = $rootScope.user.UID;
    var url = _baseUrl + tableName;
    if (typeof additionalUrl !== 'undefined'){
      //url += "?" + encodeURIComponent(additionalUrl)
      url += "?" + additionalUrl;
    }
    
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get overview of ringorders
  */
  service.fetchRingOrdersOverview = function(additionalUrl){
    var tableName = 'vw_users_orders';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    //var userId = $rootScope.user.UID;
    var url = _baseUrl + tableName;
    if (typeof additionalUrl !== 'undefined'){
      //url += "?" + encodeURIComponent(additionalUrl)
      url += "?" + additionalUrl;
    }
    
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}  
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get summary of ringorders
  */
  service.fetchRingOrdersSummary = function(additionalUrl){
    var tableName = 'vw_order_summary';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    //var userId = $rootScope.user.UID;
    var url = _baseUrl + tableName;
    if (typeof additionalUrl !== 'undefined'){
      //url += "?" + encodeURIComponent(additionalUrl)
      url += "?" + additionalUrl;
    }
    
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}  
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get overview of ringorders
  */
  service.fetchRingOrdersStatus = function(additionalUrl){
    var tableName = 'ringorderstatus';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    //var userId = $rootScope.user.UID;
    var url = _baseUrl + tableName;
    if (typeof additionalUrl !== 'undefined'){
      //url += "?" + encodeURIComponent(additionalUrl)
      url += "?" + additionalUrl;
    }
    
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get history of given ring
  */
  /*service.fetchRingHistory = function(scheme, ringnumber){
    var tableName = 'vw_ring_history';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    // additional url
    // scheme
    var additionalUrl = "?where=ID_RingingScheme is '"+scheme+"'";
    if (scheme == 'CZP'){
      var fullrn = fullRingNumber(ringnumber);
      if (fullrn == ringnumber){
        additionalUrl += " and RingNumber is '" + ringnumber + "'";
      } else {
        additionalUrl += " and (RingNumber is '" + ringnumber + "' or RingNumber is '" + fullrn + "')";
      }      
    }
    var url = _baseUrl + tableName + additionalUrl;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }*/

  /*
  * get ring overview
  */
  service.fetchRingsOverview = function(serie){
    var tableName = 'vw_rings_overview';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var userId = $rootScope.user.UID;
    var url = _baseUrl + tableName;
    if (typeof serie !== 'undefined'){
      //url += "?" + encodeURIComponent(additionalUrl)
      url += "?serie=" + serie;
    }
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get ring overview
  */
  service.fetchRings = function(additionalUrl){
    var tableName = 'vw_rings';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    //var userId = $rootScope.user.UID;
    var url = _baseUrl + tableName;
    if (typeof additionalUrl !== 'undefined'){
      //url += "?" + encodeURIComponent(additionalUrl)
      url += "?" + additionalUrl;
    }
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get list of rings for given user
  */
  service.fetchRingsWithUsers = function(additionalUrl){
    var tableName = 'vw_rings_with_users';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName ;
    if (typeof additionalUrl !== undefined){
      //url += '?' + encodeURIComponent(additionalUrl)
      url += additionalUrl;
    }
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * edit ring
  */
  service.editRingsWithUsers = function(data){
    var tableName = 'vw_rings_with_users';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName;
    $http({
      method  :'PUT',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }  

  /*
  * make ring order
  */
  service.makeRingOrder = function(data){
    var tableName = 'ringorder';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName;
    $http({
      method  :'POST',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  } 

  /*
  * edit ring order
  */
  service.editRingOrder = function(data){
    var tableName = 'ringorder';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName;
    $http({
      method  :'PUT',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }  


  /*
  * get list of ringtypes
  */
  service.fetchRingTypes = function(all, scheme){
    var tableName = 'ringtype';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var userId = $rootScope.user.UID;
    // fetch only active ringtypes
    var url = _baseUrl + tableName
    if (!all){
      url += '?where=Active is 1';
      if (scheme) {
        url += ' and ID_RingingScheme is \'' + scheme + '\'';
      }
    } else if (scheme) {
      url += '?where=ID_RingingScheme is \'' + scheme + '\'';
    }
    //console.log(url);
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * get list of ringstatus
  */
  service.fetchRingStatus = function(){
    var tableName = 'ringstatus';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var userId = $rootScope.user.UID;
    var url = _baseUrl + tableName;
    $http({
      method: 'GET',
      url: url,
      withCredentials: true,
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * lost ring
  */
  service.lostRing = function(data){
    var tableName = 'lostring';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var userId = $rootScope.user.UID;
    var url = _baseUrl + tableName;
    data['UID'] = userId;
    console.log(data);
    $http({
      method  :'PUT',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  /*
  * edit ring
  */
  service.editRing = function(data){
    var tableName = 'ring';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var url = _baseUrl + tableName;
    $http({
      method  :'PUT',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }  

  /*
  * register rings to given user
  */
  service.registerRings = function(data){
    var tableName = 'ring';
    var deferred = $q.defer();
    var userToken = localStorage.getItem('userToken');
    var userId = $rootScope.user.UID;
    var url = _baseUrl + tableName;
    data['UID'] = userId;
    $http({
      method  :'POST',
      url: url,
      data: data,
      withCredentials: true,
      headers :{'authorization':'Basic ' + userToken}
    }).then(function(response){
      deferred.resolve(response.data);
    })
    return deferred.promise;
  }

  return service;

});
